import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CouponFormComponent } from './coupon-form.component';
import { CouponFormResolve } from './coupon-form.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/admin/coupons/edit/:id',
        component: CouponFormComponent,
        resolve: {
          coupons: CouponFormResolve,
        },
      },
      {
        path: 'manage/admin/coupons/add',
        component: CouponFormComponent,
        resolve: {
          coupons: CouponFormResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class CouponFormRoutingModule {}
